export function hasObjectFieldChanged(object, fields = []) {
  if (!object) {
    throw new Error('ObjectValidator called without object');
  }
  return (value) => fields.every(f => object[f] !== value);
}

const ObjectValidator = {
  hasObjectFieldChanged,
};

export default ObjectValidator;
